import { IApiUserGroup } from 'multirpc-sdk';

import { IAccount } from 'modules/common/types';

export const convertGroupsIntoAccounts = (groups: IApiUserGroup[]) =>
  groups.map<IAccount>(
    (
      {
        address,
        comment,
        company_type: companyType,
        invite_cnt: invitesCount,
        is_enterprise: isEnterprise,
        is_freemium: isFreemium,
        is_suspended: isSuspended,
        member_cnt: membersCount,
        members_limit: membersLimit,
        name,
        user_role: role,
      },
      index,
    ) => ({
      address,
      comment,
      companyType,
      index: index + 1,
      invitesCount,
      isEnterprise,
      isFreemium,
      isSuspended,
      membersCount,
      membersLimit,
      name,
      role,
    }),
  );
